import { CalendarOutlined } from "@ant-design/icons";
import { Add, Close, Delete, Edit, Person } from '@mui/icons-material';
import { Alert, Button, IconButton, Modal, Snackbar } from '@mui/material';
import { Card, Col, DatePicker, Empty, Input, Pagination, Row, Select, Tooltip } from "antd";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import VideoPicker from "components/AdminBooks/VideoPicker";
import { DeleteModal } from "components/Dialog";
import Loading from "components/Loading";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { cloneDeep, get, has } from "lodash";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useWhatsNew } from "store/whatsNew/selectors";
import {
  handleCreateWhatsNew,
  handleDeleteWhatsNew,
  handleListWhatsNew,
} from "store/whatsNew/thunks";
import styled from "styled-components";
import SunEditor from "suneditor-react";
import {
  align,
  blockquote,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  textStyle,
} from "suneditor/src/plugins";
import { GroupImage, MascotImage } from "utils/assets/images";
import "./whatsnew.css";
import SentryWrap from 'components/Sentry';

const FilterContainer = styled.span`
font-size: 17px;
font-weight: 500;
cursor: pointer;
`;

const ModalContent = styled.div`
  left: 50%;
  width: 50vw;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  background: linear-gradient(270deg, #08080c 0%, #0e111b 100%);
  border-radius: 20px;
  min-height: 75vh;
  max-height: 90vh;
  overflow: auto;
  @media only screen and (max-width: 600px) {
    width: 90%;
  }
  @media only screen and (min-width: 600px) and (max-width: 1068px) {
    width: 80%;
  }
  @media only screen and (min-width: 1068px) and (max-width: 1291px) {
    width: 70%;
    left: 57%;
  }
`;
const ModalConfigArea = styled.div`
  // min-height:75vh;
  // max-height:90vh;
  // overflow:auto;
  // margin-top:10px;
`;
const EditWhatsNew = ({ editResourseModal, onCloseModal, item, whatsNew, showSnack }) => {
  const showAlert = useAlert();
  const [content, setContent] = useState("");
  const [date, setDate] = useState(dayjs());
  const [shortContent, setShortContent] = useState("");
  const [videoObj, setVideoObj] = useState({});
  const [createLoading, setCreateLoading] = useState(false);
  const dispatch = useDispatch();
  const [seeImages, setSeeImages] = useState([]);
  const [posterImage, setPosterImage] = useState(get(videoObj, "poster"));
  const [selectedRoles, setSelectedRoles] = useState([]);

  useEffect(() => {
    if (item?.id) {
      setVideoObj(item);
      setShortContent(get(item, "short_description", ""));
      setContent(get(item, "long_description", ""));
      setSeeImages(get(item, "image_urls", ""));
      setSelectedRoles(get(item, "user_role", ""));
      const itemDate = get(item, "create_date");
      if (itemDate) {
        setDate(dayjs(itemDate));
      }
    } else {
      const nextVersion = (whatsNew || 0) + 1;
      setVideoObj((prev) => ({ ...prev, new_version: `${nextVersion}.0` }));
    }
  }, [item]);

  // const fetchItem = async () => {
  //   await dispatch(handleListWhatsNew());
  //   setLoading(false);
  // };

  // useEffect(() => {
  //   fetchItem();
  // }, []);

  const onClearAllState = () => {
    setVideoObj({});
    setShortContent("");
    setContent("");
    setDate(dayjs());
    setSeeImages([]);
    setPosterImage("");
    setSelectedRoles([]);
    onCloseModal();
  };

  const handleImageChange = (item) => {
    const newImageUrl = item.url;
    setPosterImage(newImageUrl);
    // Update the state to include the new image
    setSeeImages([...seeImages, newImageUrl]);
  };

  const handleDelete = (index) => {
    const newImages = seeImages.filter((_, i) => i !== index);
    setSeeImages(newImages);

    // Check if the deleted image is the poster image
    if (seeImages[index] === posterImage) {
      setPosterImage("");
    }
  };

  const onChangeValue = (key, value) => {
    const re = cloneDeep(videoObj);
    re[key] = value;
    setVideoObj(re);
  };
  const handleEditorChange = (content) => {
    setContent(content);
  };

  const handleEditorShortChange = (content) => {
    setShortContent(content);
  };
  const onCreateOrUpdate = async () => {
    if (!get(videoObj, "new_version")) {
      showSnack("Version is required", "error");
      return;
    }

    if (!get(videoObj, "title")) {
      showSnack("Title is required", "error");
      return;
    }

    if (selectedRoles?.length === 0) {
      showSnack("User role is required", "error");
      return;
    }

    if (seeImages?.length === 0) {
      showSnack("At least one image is required", "error");
      return;
    }
    const createData = {
      new_version: get(videoObj, "new_version"),
      title: get(videoObj, "title", ""),
      create_date: date ? date.format("YYYY-MM-DD") : null,
      long_description: content,
      short_description: shortContent,
      image_urls: seeImages?.length > 0 ? seeImages : [],
      video_url: get(videoObj, "video_url", ""),
      user_role: selectedRoles,
    };

    const updateData = {
      ...item,
      new_version: get(videoObj, "new_version"),
      title: get(videoObj, "title", ""),
      create_date: date ? date.format("YYYY-MM-DD") : null,
      long_description: content,
      short_description: shortContent,
      image_urls: seeImages?.length > 0 ? seeImages : [],
      video_url: get(videoObj, "video_url", ""),
      user_role: selectedRoles,
    };
    setCreateLoading(true);
    if (has(item, "id")) {
      const result = await dispatch(handleCreateWhatsNew(updateData));
      if (result?.id) {
        showAlert("Whats New updated successfully", "success");
        onClearAllState();
      } else {
        showAlert("Something went wrong, please try again!", "error");
      }
    } else {
      const result = await dispatch(handleCreateWhatsNew(createData));
      if (result?.id) {
        showAlert("Whats New created successfully", "success");
        onClearAllState();
      } else {
        showAlert("Something went wrong, please try again!", "error");
      }
    }
    setCreateLoading(false);
  };

  const handleDateChange = (date) => {
    setDate(date);
  };

  const userRolesTeacher = [
    { label: "Teacher", value: "teacher" },
    { label: "Student", value: "student" },
    { label: "District Admin", value: "admin" },
  ];

  return (
    <Modal
      open={editResourseModal}
      onClose={() => {}}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent>
        <Row style={{ justifyContent: "space-between" }}>
          <div className="allWhatsTopSection">
            <div>
              <img src={MascotImage} alt="MascotImage" />
            </div>
            <div
              className="whatsNewTopText"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <label style={{ marginBottom: 8 }}>What’s New</label>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <span
                  style={{ color: "#A6A6A6", fontSize: 24, fontWeight: 500 }}
                >
                  v
                </span>
                <Input
                  placeholder="Version"
                  size="small"
                  style={{ width: 100 }}
                  value={get(videoObj, "new_version", "")}
                  onChange={(e) => {
                    onChangeValue("new_version", e.target.value);
                  }}
                />
                <DatePicker
                  size="small"
                  value={date}
                  onChange={handleDateChange}
                  format="DD MMM YYYY"
                  style={{ width: 120 }}
                  suffixIcon={<CalendarOutlined />}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  popupStyle={{ zIndex: 2000 }}
                  defaultValue={dayjs()}
                />
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Filter by role"
                  className="rounded-select adminMultiSelect"
                  style={{ width: 300 }}
                  options={userRolesTeacher}
                  value={selectedRoles}
                  onChange={(selectedValues) => {
                    setSelectedRoles(selectedValues);
                  }}
                  dropdownStyle={{
                    zIndex: 9999,
                  }}
                />
              </div>
            </div>
          </div>
          <IconButton onClick={onClearAllState} style={{ padding: 0 }}>
            <Close
              color="secondary"
              style={{
                color: "#A6A6A6",
                borderRadius: "20px",
                border: "2px solid #915FEF",
                padding: "4px",
                height: "30px",
                width: "30px",
              }}
            />
          </IconButton>
        </Row>
        <ModalConfigArea>
          <Row>
            <Col xs={24}>
              <div className="allWhatsMidSection">
                <div className="whatsNewMidSection">
                  <img src={GroupImage} alt="GroupImage" />
                  <p>
                    Presenting <span>New Tools</span>
                  </p>
                </div>
                <div className="whatsNewMidText">
                  <span>More than just textbooks</span>
                </div>
              </div>
            </Col>
            <Col xs={24}>
              <div style={{ marginTop: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <span
                    style={{
                      color: "#A6A6A6",
                      fontWeight: 500,
                      fontSize: "17px",
                    }}
                  >
                    Title
                  </span>
                  <Input
                    placeholder="Enter title"
                    value={get(videoObj, "title", "")}
                    onChange={(e) => {
                      onChangeValue("title", e.target.value);
                    }}
                    style={{ flex: 1 }}
                  />
                </div>
                <h3
                  style={{
                    color: "#fff",
                    margin: "0 0 10px 0",
                    fontWeight: 500,
                    borderBottom: "2px solid #fff",
                    display: "inline-block",
                    fontSize: "19px",
                  }}
                >
                  Video
                </h3>

                <VideoPicker
                  poster={get(videoObj, "poster")}
                  src={get(videoObj, "video_url")}
                  onChange={(item) => {
                    onChangeValue("video_url", item.url);
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                {/* ✅ Long Description Heading */}
                <h3
                  style={{
                    color: "#fff",
                    margin: "0 0 10px 0",
                    fontWeight: 500,
                    borderBottom: "2px solid #fff",
                    display: "inline-block",
                    fontSize: "19px",
                  }}
                >
                  Long Description
                </h3>

                <SunEditor
                  onChange={handleEditorChange}
                  setContents={content}
                  height="100%"
                  placeholder="Please type here..."
                  setOptions={{
                    height: "100%",
                    width: "100%",
                    showPathLabel: false,
                    buttonList: [
                      ["undo", "redo"],
                      ["font", "fontSize", "formatBlock"],
                      ["bold", "underline", "italic", "strike"],
                      ["fontColor", "hiliteColor"],
                      ["removeFormat"],
                      ["outdent", "indent"],
                      ["align", "horizontalRule", "list", "lineHeight"],
                    ],
                    plugins: [
                      blockquote,
                      align,
                      font,
                      fontColor,
                      fontSize,
                      formatBlock,
                      hiliteColor,
                      horizontalRule,
                      lineHeight,
                      list,
                      paragraphStyle,
                      textStyle,
                    ],
                  }}
                  setDefaultStyle="text-align: left; height:100%; min-height:150px;"
                  style={{ color: "#000000" }}
                  // disable={!isTeacher ? true : false}
                />
              </div>
              <div className="WhatsNewImagePicker">
                <h3
                  style={{
                    color: "#fff",
                    margin: "0 0 10px 0",
                    fontWeight: 500,
                    borderBottom: "2px solid #fff",
                    display: "inline-block",
                    fontSize: "19px",
                  }}
                >
                  Image
                </h3>
                <div className="whatsNewMidImgPicker">
                  <PageImagePicker
                    src={posterImage}
                    path={`/resources`}
                    onChange={handleImageChange}
                    hasDescription={false}
                  />
                </div>
                <div className="allWhatsNewUploadImg">
                  {seeImages.map((image, index) => (
                    <div className="whatsNewUploadImg">
                      <img
                        key={index}
                        src={image}
                        alt={`Uploaded ${index}`}
                        style={{}}
                      />
                      <button
                        className="deleteButton"
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                {/* <div className='whatsNewFeature'>
                        <img src={FeaturesImage} alt='GroupImage' />
                        <span>Major Features</span>
                    </div> */}
                {/* {whatsNewData.map((item, index) => (
                  <div className="whatsNewFeature" key={index}>
                    <img src={FeaturesImage} alt="GroupImage" />
                    <span>{item.title}</span>
                  </div>
                ))} */}
                <div style={{ marginTop: "20px" }}>
                  <h3
                    style={{
                      color: "#fff",
                      margin: "0 0 10px 0",
                      fontWeight: 500,
                      borderBottom: "2px solid #fff",
                      display: "inline-block",
                      fontSize: "19px",
                    }}
                  >
                    Short Description
                  </h3>
                  <SunEditor
                    onChange={handleEditorShortChange}
                    setContents={shortContent}
                    height="100%"
                    placeholder="Please type here..."
                    setOptions={{
                      height: "100%",
                      width: "100%",
                      showPathLabel: false,
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize", "formatBlock"],
                        ["bold", "underline", "italic", "strike"],
                        ["fontColor", "hiliteColor"],
                        ["removeFormat"],
                        ["outdent", "indent"],
                        ["align", "horizontalRule", "list", "lineHeight"],
                      ],
                      plugins: [
                        blockquote,
                        align,
                        font,
                        fontColor,
                        fontSize,
                        formatBlock,
                        hiliteColor,
                        horizontalRule,
                        lineHeight,
                        list,
                        paragraphStyle,
                        textStyle,
                      ],
                    }}
                    setDefaultStyle={
                      "text-align: left; height:100%; min-height:150px;"
                    }
                    style={{ color: "#000000" }}
                    // disable={!isTeacher ? true : false}
                  />
                </div>
                <div style={{ textAlign: "center" }}>
                  <Button
                    disabled={createLoading}
                    className="WhatsNewBttn"
                    variant="contained"
                    color="primary"
                    sx={{
                      mt: 4,
                      color: "#fff", // force white text if theme isn't applying it
                    }}
                    onClick={onCreateOrUpdate}
                  >
                    {createLoading ? <Loading white size={15} /> : null}
                    {has(item, "id") ? "Update" : "Create"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>
  );
};
export default function LearnScreen() {
  const showAlert = useAlert();
  const whatsNew = useWhatsNew();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 9;
  const [deleteToggle, setDeleteToggle] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [videoModalInfo, setVideoModalInfo] = React.useState({
    open: false,
    item: null,
  });
  const [whatsNewAllData, setWhatsNewAllData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });
  const paginatedData = whatsNewAllData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const showSnack = (message, severity = "info") => setSnack({ open: true, message, severity });

  useEffect(() => {
    dispatch(handleListWhatsNew());
  }, []);

  useEffect(() => {
    if (whatsNew) {
      setWhatsNewAllData(whatsNew);
    }
  }, [whatsNew]);

  const onAdd = () => {
    setVideoModalInfo({ open: true, item: {} });
  };

  const userRoles = [
    { label: "Teacher", value: "teacher" },
    { label: "Student", value: "student" },
    { label: "District Admin", value: "admin" },
  ];

  const onDeleteItem = async () => {
    if (has(selectedItem, "id")) {
      setLoading(true);
      const deleteResult = await dispatch(
        handleDeleteWhatsNew(selectedItem.id)
      );
      if (deleteResult?.id) {
        showAlert("Deleted successfully", "success");
      } else {
        showAlert("Something went wrong, please try again!", "error");
      }
      setLoading(false);
    }
    setSelectedItem(null);
    setDeleteToggle(false);
  };

  const handleEdit = (item) => {
    setVideoModalInfo({ open: true, item: item });
  };

  // const handleRoleChange = (selectedValues) => {
  //   if (selectedValues?.length === 0) {
  //     setWhatsNewAllData(whatsNew);
  //     return;
  //   }
  //   const filterRole = whatsNew.filter((item) => {
  //     // Check if any role in item.user_role matches selectedValues
  //     return item.user_role.some((role) => selectedValues.includes(role));
  //   });
  //   setWhatsNewAllData(filterRole);
  // };
  const handleRoleChange = (selectedValues) => {
    let filteredData = whatsNew;
  
    if (selectedValues?.length > 0) {
      filteredData = filteredData.filter((item) =>
        item.user_role.some((role) => selectedValues.includes(role))
      );
    }
  
    if (searchQuery.trim() !== "") {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.new_version.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
  
    setWhatsNewAllData(filteredData);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
  
    let filteredData = whatsNew;
  
    if (value.trim() !== "") {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(value.toLowerCase()) ||
        item.new_version.toLowerCase().includes(value.toLowerCase())
      );
    }
  
    setWhatsNewAllData(filteredData);
  };

  return (
    <SentryWrap>
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
      <EditWhatsNew
        editResourseModal={videoModalInfo.open}
        item={videoModalInfo.item}
        onCloseModal={() => setVideoModalInfo({ open: false, item: null })}
        whatsNew={whatsNew?.length}
        showSnack={showSnack}
      />
      <DeleteModal
        deleteToggle={deleteToggle}
        setDeleteToggle={setDeleteToggle}
        onDelete={onDeleteItem}
        message={`Are you sure you want to delete "${get(selectedItem, "title")}"?`}
        loading={loading}
      />
      <Button
        variant="contained"
        color="primary"
        style={{}}
        onClick={onAdd}
        sx={{ color: "white" }}
      >
        <Add /> What's New
      </Button>
      {/* <div
        style={{
          marginTop: 24,
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <Input
          placeholder="Search by title or version"
          value={searchQuery}
          onChange={handleSearch}
          style={{ width: 300 }}
        />
        <Select
          mode="multiple"
          allowClear
          placeholder="Filter by role"
          className="rounded-select"
          style={{ width: 300, marginTop: 24 }}
          options={userRoles}
          onChange={(selectedValuesOption) => {
            // setSelectRoleAdmin(selectedValuesOption)
            handleRoleChange(selectedValuesOption);
          }}
        />
      </div> */}
      <div style={{ marginTop: "24px" }}>
        <FilterContainer className="FilterHeading">
          <Card type="inner" title="Filters">
            <Row style={{ display: "flex", alignItems: "center" }}>
              <Col xs={12} lg={12} md={12} className="ColCardPadding">
                <Card style={{ width: "100%" }}>
                  <Input
                    placeholder="Search by title or version"
                    bordered={false}
                    style={{ height: "32px" }}
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </Card>
              </Col>
              <Col xs={12} lg={12} md={12} className="ColCardPadding">
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Filter by role"
                  className="rounded-select"
                  style={{ width: "-webkit-fill-available" }}
                  options={userRoles}
                  onChange={(selectedValuesOption) => {
                    // setSelectRoleAdmin(selectedValuesOption)
                    handleRoleChange(selectedValuesOption);
                  }}
                />
              </Col>
            </Row>
          </Card>
        </FilterContainer>
      </div>
      <Row className="" gutter={[25, 0]}>
        <Col xs={24} sm={24} md={24}>
          <div className="learnContent">
            {paginatedData?.length === 0 && (
              <div
                style={{
                  marginTop: 80,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Empty description="No Data Found" />
              </div>
            )}
            <div className="myCategorys">
              {paginatedData.length > 0 &&
                paginatedData.map((category) => (
                  <div
                    key={category.id}
                    className="myCategoryList OneWayVideoCover"
                  >
                    <div className="card-resource ShowDetailBnr">
                      <div className="btnsGrpMain">
                        <div
                          className="btnsGrpTxt"
                          style={{ justifyContent: "center" }}
                        >
                          <Button
                            className="btnsTxtYellow"
                            onClick={() => handleEdit(category)}
                          >
                            <Edit style={{ fontSize: 20, marginRight: 3 }} />
                            Edit
                          </Button>
                          <Button
                            className="btnsTxtDelete"
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                              setSelectedItem(category);
                              setDeleteToggle(true);
                            }}
                          >
                            <Delete style={{ fontSize: 20, marginRight: 3 }} />
                            Delete
                          </Button>
                        </div>
                      </div>
                      {/* <img src="" alt="" /> */}
                      <img src={category.image_urls[0]} alt="Bird" />
                    </div>

                    <div className="whatsNewBtnTxt">
                      <div className="onway-whats-new-txt">
                        {category.title.length > 25 ? (
                          <Tooltip title={category.title}>
                            <div className="onway-whats-new-txt">
                              {category.title.slice(0, 25)}...
                            </div>
                          </Tooltip>
                        ) : (
                          <div className="onway-whats-new-txt">
                            {category.title}
                          </div>
                        )}
                      </div>
                      <div className="btm1Category">
                        <div className="persionIconImg">
                          <Person className="iconClrChange" />
                          {/* <span>ONE WAY EDUCATION</span> */}
                          <span>
                            {category.new_version} - {category.create_date}
                          </span>
                        </div>
                      </div>
                      {/* <div className="btm1Category"> */}
                      <div className="persionIconImg">
                        <Person className="iconClrChange" />
                        {/* <span>ONE WAY EDUCATION</span> */}
                        <span style={{ color: "#fff" }}>
                          {category.user_role.join(", ")}
                        </span>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                ))}
            </div>
            {whatsNewAllData.length > pageSize && (
              <div style={{ marginTop: 24, textAlign: "center" }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={whatsNewAllData.length}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>

      <div></div>
    </SentryWrap>
  );
}
